import { TablerIconMap } from './iconMap';
import type { IconNames } from './types';

export type IconSizes = 'md' | 'lg';
export const IconSizeMap = {
	md: 20,
	lg: 48,
};
export const IconStrokeWidthMap = {
	// We use `2.25` for `md`, which maps to `1.5` in the figma designs. This is
	// due to scaling issues.
	md: 2.25,
	lg: 1.5,
};

// List of all available icon names - derived from TablerIconMap
export const allIconNames = Object.keys(TablerIconMap) as IconNames[];
